<div class="error-wrapper">
    <coreui-error-state header="404" subheader="Page Not Found" illustration="somethingMissing">
        Please check the URL.
    </coreui-error-state>
</div>